<template>
  <SelectSingleInput
    v-model="model"
    :items="items"
    item-text="xtfGroupText"
    item-value="xrfGroupCd"
    :label="label"
    :disabled="disabled"
    :loading="loading"
    :required="required"
  />
</template>

<script>
import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'

export default {
  name: 'XrfGroupInput',

  mixins: [APIUtils, Message],

  components: { SelectSingleInput },

  props: {
    value: {
      type: String,
      default: '',
      required: true,
    },
    label: {
      type: String,
      required: false,
      default: function () {
        return this.$t('ELE0519')
      },
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    validOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      items: [],
      loading: false,
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },
  },

  async mounted() {
    try {
      this.loading = true
      let params = {
        validOnly: this.validOnly,
      }

      const elements = await API.get('/master/xrfGroups', params)
      elements.forEach((element) => {
        element['xtfGroupText'] = element['xrfGroupCd'] + ' : ' + element['xrfGroupName']
        this.items.push(element)
      })
    } catch (error) {
      this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0241') })))
    } finally {
      this.loading = false
    }
  },
}
</script>
